import { useContext, useEffect, useState } from "react";

import { SearchMoviesAssetsRequest } from "../../../../common/api/master-api/assets/search/movie-requests-responses/SearchMoviesAssetsRequest";
import { SearchMoviesAssetsResponse } from "../../../../common/api/master-api/assets/search/movie-requests-responses/SearchMoviesAssetsResponse";
import { useAssetsApi } from "../../../../common/api/master-api/assets/useAssetsApi";
import { AssetItem, mapToAssetsListItem } from "../../common/AssetItem";
import { SingleMovieContext } from "../context/SingleMovieContext";
import { MovieAssetsListUrlFilters } from "./useMovieAssetsListUrlFilters";

interface UseMovieAssetsListProps {
    filters: MovieAssetsListUrlFilters;
}

export const useMovieAssetsList = (props: UseMovieAssetsListProps) => {
    const { movieId, movie } = useContext(SingleMovieContext);

    const { filters } = props;

    const { searchMovies } = useAssetsApi();

    const [items, setItems] = useState<AssetItem[]>([]);
    const [totalItems, setTotalItems] = useState<number>(0);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);
        const request: SearchMoviesAssetsRequest = {
            movieId: movieId,
            statusIds: filters.statusIds,
            page: filters.page,
            pageSize: filters.pageSize,
            sortBy: filters.sortBy,
            sortOrder: filters.sortOrder,
            distributorIds: filters.distributorIds,
            versionTypeIds: filters.versionTypeIds,
            types: filters.types,
            origins: filters.origins,
            recordTypes: filters.recordTypes,
            createdDateFrom: filters.createdDateFrom?.toISOString(),
            createdDateTo: filters.createdDateTo?.toISOString(),
            updatedDateFrom: filters.updatedDateFrom?.toISOString(),
            updatedDateTo: filters.updatedDateTo?.toISOString(),
            trailers: filters.trailers
        };

        searchMovies(request)
            .then((response: SearchMoviesAssetsResponse) => {
                const newItems = response.items.map(mapToAssetsListItem);

                setItems(newItems);
                setTotalItems(response.totalCount);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [movieId, filters]);

    return {
        items,
        totalItems,
        subtype: movie.subtype,
        isLoading
    };
};
